import AboutUs from '../components/blocks/about-us';
import AsxWidgets from '../components/blocks/asx-widgets';
import Brands from '../components/blocks/brands';
import OurValues from '../components/blocks/our-values';
import HeroSolvar from '../components/blocks/hero-solvar';
import MainLayout from '../components/layouts/main-layout';
import WebsiteSections from '../components/blocks/website-sections';
import AfsLogo from '../public/img/logos/afs_01.svg';
import GcfLogo from '../public/img/logos/gcf_01.svg';
import BennjiLogo from '../public/img/logos/bennji_01.png';
import Money3Logo from '../public/img/logos/money3_02.svg';
import ScrollDownArrow from '../components/scroll/scroll-down-arrow';
import Head from 'next/head';
import NewBrand from '../components/blocks/new-brand';

const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": "https://www.solvar.com.au/#organization",
    "name": "Solvar Limited",
    "url": "https://www.solvar.com.au/",
    "logo": "https://www.solvar.com.au/img/logos/solvar_01.svg",
    "foundingDate": "2005-11-25",
    "identifier": [
        {
            "@type": "PropertyValue",
            "propertyID": "ABN",
            "value": "63 117 296 143"
        },
        {
            "@type": "PropertyValue",
            "propertyID": "Australian Credit Licence",
            "value": "389 782"
        },
        {
            "@type": "PropertyValue",
            "propertyID": "ASX",
            "value": "SVR"
        }
    ],
    "address": {
        "@type": "PostalAddress",
        "streetAddress": "Level 1, 40 Graduate Road",
        "addressLocality": "Bundoora",
        "addressRegion": "VIC",
        "postalCode": "3083",
        "addressCountry": "AU"
    },
    "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+61-3-9093-8255",
        "contactType": "Investor Relations",
        "areaServed": "AU",
        "availableLanguage": "en"
    },
    "sameAs": [
        "https://au.linkedin.com/company/solvarlimited",
        "https://www.asx.com.au/markets/company/SVR"
    ],
    "brand": [
        {
            "@type": "Brand",
            "name": "Money3",
            "url": "https://www.money3.com.au/"
        },
        {
            "@type": "Brand",
            "name": "Automotive Financial Services",
            "alternateName": "AFS",
            "url": "https://www.afs.com.au/"
        },
        {
            "@type": "Brand",
            "name": "Bennji",
            "url": "https://www.bennji.com.au/"
        },
        {
            "@type": "Brand",
            "name": "Go Car Finance",
            "url": "https://www.gocar.co.nz/"
        }
    ]
};

export default function HomePage() {
    return (
        <MainLayout>
            <Head>
                <title>Solvar - Specialist Finance Providers</title>
                <script
                    key="schema"
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
                />
            </Head>
            <HeroSolvar />
            <div id="scrollDownAnchor"></div>
            <AsxWidgets />
            <NewBrand />
            <AboutUs />
            <WebsiteSections />
            <OurValues />
            <Brands
                items={[
                    {
                        src: AfsLogo,
                        href: "https://www.afs.com.au/",
                        alt: "Automotive Financial Services"
                    },
                    {
                        src: GcfLogo,
                        href: "https://www.gocar.co.nz/",
                        alt: "Go Car Finance"
                    },
                    {
                        src: Money3Logo,
                        href: "https://www.money3.com.au/",
                        alt: "Money3"
                    },
                    {
                        src: BennjiLogo,
                        href: "https://bennji.com.au/",
                        alt: "Bennji"
                    }
                ]}
            />
            <ScrollDownArrow anchor="scrollDownAnchor" />
        </MainLayout>
    );
}